import styled from "styled-components";
import { GrayColors, TextColorNames } from "@smartsuite/types";

export const DatePickerWrapper = styled.div`
  .menu-option-wrapper__list {
    padding: 0;
  }
  .react-datepicker__day {
    margin: 0 13px;
  }
  .react-datepicker__day-name {
    margin: 0 13px;
    height: 19px;
  }

  .react-datepicker__aria-live {
    display: none;
  }
`;

export const NumberInputFieldWrapper = styled.div<{ value?: number }>`
  display: flex;
  width: 133px;
  margin-left: 6px;
  min-width: 107px;
  position: relative;
  align-items: center;

  .react-number-input-field__suffix-text {
    right: ${({ value }) => {
      if (value !== undefined) {
        if (value < -99) {
          return 24;
        }
        if (value > 99) {
          return 27;
        }
      }
      return 30;
    }}px;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  .picker-input-field__placeholder {
    margin-left: 14px;
  }
  .is-clear {
    background-color: ${GrayColors["G-0-5"]};
    .picker-input-field__placeholder {
      color: ${GrayColors["G-4"]};
    }
  }
`;

export const AddIntervalButton = styled.span`
  font-family: inherit;
  font-style: normal;
  font-weight: 700;
  font-size: 9px;
  line-height: 11px;
  color: ${TextColorNames.secondary};
  display: flex;
  align-items: baseline;
  text-transform: uppercase;
  padding-right: 3px;
  position: absolute;
  top: -22px;
  right: 0;

  transition: right 250ms ease-in-out;
`;

export const StyledTitle = styled.div`
  font-family: inherit;
  font-size: 13px;
  color: ${TextColorNames.secondary};
  line-height: 18px;
  display: flex;
  margin-right: 6px;
`;
